const GOLD = 'var(--user-gold, #D4AF37)'

export default function SectionHeading({
  title,
  subtitle,
  titleColor = GOLD,
  lineColor = GOLD,
  subtitleColor = 'rgba(222,214,200,0.85)',
}) {
  return (
    <div className="relative text-center">

      {/* HEADING ROW */}
      <div
        className="
          mb-2
          flex
          items-center
          justify-center
          gap-2

          sm:mb-3
          sm:gap-3

          md:mb-4
          md:gap-4
        "
      >
        {/* LEFT LINE */}
        <span
          data-anim="eyebrow-line"
          className="
            h-px
            w-7
            origin-right

            sm:w-10

            md:w-16
          "
          style={{
            backgroundColor: lineColor,
          }}
        />

        {/* TITLE */}
        <h2
          data-anim="heading"
          className="
            text-[24px]
            font-medium
            leading-[1.15]
            tracking-[0.14em]

            sm:text-[30px]
            sm:tracking-[0.16em]

            md:text-5xl
            md:tracking-[0.18em]
          "
          style={{
            color: titleColor,
          }}
        >
          {title}
        </h2>

        {/* RIGHT LINE */}
        <span
          data-anim="eyebrow-line"
          className="
            h-px
            w-7
            origin-left

            sm:w-10

            md:w-16
          "
          style={{
            backgroundColor: lineColor,
          }}
        />
      </div>

      {/* SUBTITLE */}
      <p
        data-anim="subtitle"
        className="
          mt-1.5
          text-[12px]
          leading-[1.4]

          sm:mt-2
          sm:text-sm

          md:mt-3
          md:text-base
        "
        style={{
          color: subtitleColor,
        }}
      >
        {subtitle}
      </p>
    </div>
  )
}